import { Component, inject } from '@angular/core';
import { SpinnerService } from '@tw/services';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'tw-spinner',
  standalone: true,
  imports: [ProgressSpinner],
  template: `
    @if (spinnerService.visible()) {
      <div class="spinner-overlay">
        <p-progress-spinner ariaLabel="loading" />
      </div>
    }
  `,
  styles: [
    `
      .spinner-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.5); /* light dim effect */
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        pointer-events: all;
      }
    `,
  ],
})
export class SpinnerComponent {
  protected spinnerService = inject(SpinnerService);
}
